import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ROOT_FONT_SIZE } from 'HubStyleTokens/sizes';
import { EERIE } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import StyledZeroState from './StyledZeroState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EerieStyleHeading = styled.h2.withConfig({
  displayName: "NoSearchResults__EerieStyleHeading",
  componentId: "sc-1q9yadz-0"
})(["color:", ";"], EERIE);
const StyledP = styled.p.withConfig({
  displayName: "NoSearchResults__StyledP",
  componentId: "sc-1q9yadz-1"
})(["font-size:", ";color:", ";"], ROOT_FONT_SIZE, EERIE);
const NoSearchResults = () => {
  const {
    clearAllFilterValuesAndSearch
  } = useFilterValues();
  return /*#__PURE__*/_jsxs(StyledZeroState, {
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "empty-state-charts",
      width: "200px"
    }), /*#__PURE__*/_jsx(EerieStyleHeading, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noSearchResults.title"
      })
    }), /*#__PURE__*/_jsx(StyledP, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noSearchResults.body"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      onClick: clearAllFilterValuesAndSearch,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noSearchResults.button"
      })
    })]
  });
};
NoSearchResults.displayName = 'NoSearchResults';
export default NoSearchResults;